import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { CIPXQuoteRequestIntakeFormRequestDetailsBondInformationComponent } from './sections/bond-information/bond-information.component';
import { CIPXQuoteRequestIntakeFormRequestDetailsOwnersComponent } from './sections/owners/owners.component';
import { CIPXQuoteRequestIntakeFormRequestDetailsAdditionalCommentsComponent } from "./sections/additional-comments/intake-form-additional-comments.component";
import { CIPXQuoteRequestIntakeForm, CIPXQuoteRequestIntakeFormOwner, IntakeFormStep } from '../../intake-form.types';
import { getQuestionsForLayout, isCIPXQuoteRequestIntakeFormStateBond, layoutHasQuestions, requiresCredit } from '../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../intake-form.service';
import { CIPXQuoteRequestIntakeFormQuestionSetComponent } from '../../question-set/question-set.component';
import { CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent } from "./sections/screen-and-explain/screen-and-explain.component";

@Component({
  standalone: true,
  imports: [
    SharedModule,
    SharedComponentsModule,
    CIPXQuoteRequestIntakeFormRequestDetailsBondInformationComponent,
    CIPXQuoteRequestIntakeFormRequestDetailsOwnersComponent,
    // CIPXQuoteRequestIntakeFormRequestDetailsAdditionalCommentsComponent,
    // CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent
],
  selector: 'cipx-quote-request-intake-form-request-details',
  templateUrl: 'intake-form-request-details.component.html',
})
export class CIPXQuoteRequestIntakeFormRequestDetailsComponent
  implements OnInit
{
  private _intakeService = inject(CIPXQuoteRequestIntakeFormService);
  private _changeDetectorRef = inject(ChangeDetectorRef);

  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;
  @Output() companyNumberOwnersChanged = new EventEmitter<number>();


  layoutHasQuestions = layoutHasQuestions;

  selectedStateBond = this._intakeService.selectedStateBond;

  ngOnInit() {
    // this.addOwner();
  }

  get principal(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails.controls.principal;
  }

  stageComplete() {
    // Validate request details step before proceeding
    const isValid = this._intakeService.validateCurrentStep(
      IntakeFormStep.RequestDetails,
      this.quoteRequestForm,
      this.selectedStateBond()
    );

    if (isValid) {
      this._intakeService.goToStep(IntakeFormStep.AdditionalQuestions);
    } else {
      // Error handling - you might want to inject CathyService here
      console.error('Please fill in all required fields for the request details step.');
    }
  }

  // onCompanyTypeIdChanged(value: number) {
  //   if(value === 3) {
  //     this.onCompanyNumberOwnersChanged(1);
  //   } else {
  //     this.quoteRequestForm.controls.addCompanyAddress.setValue(true);
  //   }

  //   this._changeDetectorRef.detectChanges();
  // }

  // onCompanyNumberOwnersChanged(value: number) {
  //   const ownersArray = this.owners; // get the FormArray
  //   const currentCount = ownersArray.length;

  //   if (value > currentCount) {
  //     // Add owners until we have the desired count
  //     for (let i = currentCount; i < value; i++) {
  //       ownersArray.push(this.createOwnerGroup());
  //     }
  //   } else if (value < currentCount) {
  //     // Remove owners from the end until we reach the desired count
  //     for (let i = currentCount; i > value; i--) {
  //       ownersArray.removeAt(i - 1);
  //     }
  //   }
  //   this.quoteRequestForm.controls.company_number_owners.setValue(value);
  // }

  // /**
  //  * Returns the owners FormArray.
  //  */
  // get owners(): FormArray {
  //   return this.quoteRequestForm.controls.owners;
  // }

  // /**
  //  * Adds a new owner form group to the owners form array.
  //  */
  // addOwner(): void {
  //   const ownersArray = this.owners;
  //   ownersArray.push(this.createOwnerGroup());
  // }

  // /**
  //  * Removes an owner FormGroup from the owners FormArray by index.
  //  */
  // removeOwner(index: number): void {
  //   this.owners.removeAt(index);
  // }

  // /**
  //  * Creates and returns an owner form group.
  //  */
  // createOwnerGroup(): FormGroup<CIPXQuoteRequestIntakeFormOwner> {
  //   const ownerSsnValidators = [
  //     Validators.pattern('^\\d{3}-?\\d{2}-?\\d{4}$'),
  //   ];
  //   const stateBond = this._intakeService.selectedStateBond();
  //   if (stateBond && stateBond !== null && requiresCredit(stateBond)) {
  //     ownerSsnValidators.push(Validators.required)
  //   }
  //   const fg = new FormGroup<CIPXQuoteRequestIntakeFormOwner>({
  //     owner_first_name: new FormControl('', Validators.required),
  //     owner_middle_name: new FormControl(''),
  //     owner_last_name: new FormControl('', Validators.required),
  //     owner_email_address: new FormControl('', [
  //       // Validators.required,
  //       Validators.email,
  //     ]),
  //     owner_phone: new FormControl(''),
  //     owner_ssn: new FormControl('', ownerSsnValidators),
  //     owner_marital_status: new FormControl(null),
  //     owner_dob: new FormControl(''), // Consider using a date picker with proper formatting
  //     owner_years_experience: new FormControl(null, Validators.min(0)),
  //     owner_percent_owned: new FormControl(100, [
  //       Validators.min(0),
  //       Validators.max(100),
  //     ]),
  //     owner_title: new FormControl(''),
  //     owner_address_street_1: new FormControl(''),
  //     owner_address_street_2: new FormControl(''),
  //     owner_address_city: new FormControl(''),
  //     owner_address_state_abbreviation: new FormControl('', [
  //       Validators.minLength(2),
  //       Validators.maxLength(2),
  //     ]),
  //     owner_address_zip: new FormControl('', [
  //       Validators.pattern('^[0-9]{5}(-[0-9]{4})?$'),
  //     ]),
  //   });

  //   if (isCIPXQuoteRequestIntakeFormStateBond(this.quoteRequestForm.controls.stateBondSelection) && requiresCredit(this.quoteRequestForm.controls.stateBondSelection) === false) {
  //     fg.controls.owner_ssn.disable();
  //   }

  //   return fg;
  // }
}
